// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__AQ4SN","bug":"styles_bug__11AgR","message":"styles_message__bf9jl","close":"styles_close__2rqMq"};